import * as React from 'react';
import { MaskedInput } from '../MaskedInput';
import * as styles from '../InputField/styles.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var PhoneField = /*#__PURE__*/React.forwardRef(function PhoneField(props, ref) {
  var name = props.name,
    placeholder = props.placeholder,
    invalid = props.invalid,
    value = props.value,
    onValueChange = props.onValueChange,
    onKeyDown = props.onKeyDown,
    onFocus = props.onFocus,
    onBlur = props.onBlur,
    errorMessage = props.errorMessage,
    autoFocus = props.autoFocus,
    disabled = props.disabled,
    autoComplete = props.autoComplete,
    inputRef = props.inputRef;
  var handleAccept = React.useCallback(function (value) {
    if (!onValueChange) {
      return;
    }
    onValueChange(value);
  }, [onValueChange]);
  var handlePrepare = React.useCallback(function (appended, masked) {
    if (appended === '8' && masked.value === '') {
      return '';
    }
    return appended;
  }, []);
  return /*#__PURE__*/_jsxs("div", {
    ref: ref,
    className: styles['container'],
    children: [/*#__PURE__*/_jsx("div", {
      className: styles['input-group'],
      children: /*#__PURE__*/_jsx(MaskedInput, {
        inputRef: inputRef,
        autoFocus: autoFocus,
        autoComplete: autoComplete,
        placeholder: placeholder,
        onKeyDown: onKeyDown,
        onFocus: onFocus,
        onBlur: onBlur,
        prepare: handlePrepare,
        invalid: invalid,
        disabled: disabled,
        value: value,
        name: name,
        type: "tel",
        size: "M",
        mask: "{+7} (000) 000-00-00",
        onAccept: handleAccept
      })
    }), errorMessage && /*#__PURE__*/_jsx("span", {
      className: styles['error-message'],
      children: errorMessage
    })]
  });
});
PhoneField.displayName = 'PhoneField';